import React, { Fragment } from 'react';

const SelectInput = ({ input, type, placeholder, meta: { touched, error }, options }) => {
	return (
		<Fragment>
			<select
				placeholder={placeholder}
				type={type}
				className="form-control"
				value={input.value || ''}
				onBlur={input.onBlur}
				onChange={(e, data) => input.onChange(e.target.value)}
				options={options}
			>
				<option value="none">None</option>,
				{options && options.length > 0 ? (
					options.map((option, index) => (
						<option value={option.value} key={index}>
							{option.label}
						</option>
					))
				) : (
					<option value="none">None</option>
				)}
			</select>
			{touched && error && <label className="error-label">{error}</label>}
		</Fragment>
	);
};

export default SelectInput;
